<template>
    <div class="window bg">
        <div class="container">
            <menu-option v-bind:back="true" v-bind:is-white="true" v-bind:is-help="false"
                         class="container-horizontal_flex-start"  v-bind:back-route="'/menu'"></menu-option>
            <div class="img-container">
                <transition :css="false" @enter="enterAnim" appear>

                    <img v-bind:src="getCharacter.fullImage" class="img-container_img">
                </transition>

                <transition :css="false" @enter="enterAnim" appear>
                    <character-talk v-bind:text="outputText" v-bind:route="'/practice-start'"
                                    v-bind:show-name="true" v-bind:show-next="true"  v-bind:is-blue="false"></character-talk>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import CharacterTalk from '../components/CharacterTalk';
    import MenuOption from '../components/MenuOption';
    import anime from 'animejs';


    export default {
        name: "Practice",
        components: {
            CharacterTalk,
            MenuOption
        },
        computed: {
            ...mapGetters(['getCharacter', 'getPracticeText']),
        },
        watch: {},
        mounted() {
            this.outputText = this.getPracticeText[0].text;
        },
        methods: {
            enterAnim(el, done) {
                const ani = anime({
                    targets: el,
                    opacity: [0, 1],
                    easing: 'easeInQuad'
                })
            }
        },
        data() {
            return {
                step: 2,
                outputText: '',
                inc: 0,
                isRecordDone: false,
                audioRecorder: null,
                id: '',
                showResult: false,
                result: {}
            }
        }
    }
</script>

<style scoped>
</style>
